import Container from '../Container';
import React, { Component } from 'react';
import { WINDOWS_PROPS } from '../Types';
import * as _ from 'lodash';
import { getWindowDimensions } from '../../../../utility/Util';
import { H_BOX_PROPS } from './Types';

export default class HBox extends Component<H_BOX_PROPS, WINDOWS_PROPS> {
  constructor(props: any) {
    super(props);

    this.state = {
      windowDimensions: getWindowDimensions()
    };
  }

  static defaultProps = {
    hBox: true
  }

  handleResize = () => {
    this.setState({ windowDimensions: getWindowDimensions() });
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  fillCalc = () => {
    let fillWidth;
    if (!fillWidth) {
      const numberOffFillWidth = this.props.childrenWidth.filter(item => item === 'fill')?.length;
      const arrayWithoutFillAndAuto = this.props.childrenWidth.filter(item => item !== 'fill' && item !== 'auto');
      const convertNumberToString = arrayWithoutFillAndAuto.map((item, index) => typeof item === 'number' ? item.toString() + 'px' : item);
      fillWidth = (`calc((100% - ${convertNumberToString.length ? convertNumberToString.join(' - ') : '0px'}) / ${numberOffFillWidth})`);
    }
    return fillWidth;
  };

  render() {
    let {
      children,
      childrenBorderBetween,
      borderBottom,
      className = '',
      childrenWidth,
      childrenResponsive,
      autoLayout
    } = this.props;

    className = (childrenResponsive && this.state?.windowDimensions?.width <= 769) ? `!k-flex-col ${className}` : className;
    className = borderBottom ? `tp-border-bottom ${className}` : className;

    if (children?.length && typeof children !== 'string') {
      children = children?.map((item, index) => {
        if (typeof item !== 'object' || _.isEmpty(item)) {
          return item;
        } else {
          let childrenClassNames = item.props?.className ? item.props?.className : '';

          if (childrenBorderBetween && index < children?.length - 1) {
            childrenClassNames = `tp-border-right ${childrenClassNames}`;
          }

          if (childrenBorderBetween || autoLayout) {
            if (children?.length === 1) {
              childrenClassNames = childrenResponsive && this.state?.windowDimensions?.width <= 769 ? '' : childrenClassNames;
            } else if (index === 0) {
              childrenClassNames = childrenResponsive && this.state?.windowDimensions?.width <= 769 ? '' : `${childrenBorderBetween ? 'k-pr-6' : 'k-pr-3'} ${childrenClassNames}`;
            } else if (index === children?.length - 1) {
              childrenClassNames = childrenResponsive && this.state?.windowDimensions?.width <= 769 ? '' : `${childrenBorderBetween ? 'k-pl-6' : 'k-pl-3'} ${childrenClassNames} `;
            } else {
              childrenClassNames = childrenResponsive && this.state?.windowDimensions?.width <= 769 ? '' : `${childrenBorderBetween ? 'k-px-6' : 'k-px-3'} ${childrenClassNames}`;
            }
          }

          return {
            ...item,
            props:
                {
                  ...item?.props,
                  className: childrenClassNames ? childrenClassNames : '',
                  style: {
                    ...item?.props?.style,
                    width: childrenResponsive && this.state?.windowDimensions?.width <= 769 ?
                      '100%' : childrenWidth ?
                        childrenWidth[index] === 'fill' ?
                          this.fillCalc()
                          :
                          (typeof childrenWidth[index] === 'number' ?
                            childrenWidth[index].toString() + 'px'
                            :
                            childrenWidth[index])
                        :
                        autoLayout ? `calc(100%/${children?.length})` : item?.props?.style?.width
                  }
                }
          };
        }
      }
      );
    }

    const props = { ...this.props, className, children };

    return (
      <Container
        {...props}
      />
    );
  }
}
